// src/components/LanguageSwitcher.tsx
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GB, DE, RS } from 'country-flag-icons/react/3x2';

const languages = [
  { code: 'en', name: 'English', flag: GB },
  { code: 'de', name: 'Deutsch', flag: DE },
  { code: 'sr-Latn', name: 'Srpski', flag: RS },
  { code: 'sr-Cyrl', name: 'Српски', flag: RS },
];

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const FlagIcon = currentLanguage.flag;

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        className="flex items-center space-x-2 px-3 py-2 rounded-md hover:bg-gray-100"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FlagIcon className="w-5 h-5" />
        <span className="text-sm font-medium">{currentLanguage.name}</span>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
          <div className="py-1" role="menu">
            {languages.map((language) => {
              const Flag = language.flag;
              return (
                <button
                  key={language.code}
                  className={`w-full flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 
                    ${language.code === i18n.language ? 'bg-gray-50' : ''}`}
                  onClick={() => handleLanguageChange(language.code)}
                  role="menuitem"
                >
                  <Flag className="w-5 h-5" />
                  <span>{language.name}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;